/* ======= All App File Include Here ======= */
// Vuetify Css
import 'vuetify/dist/vuetify.css'

// Editor Css
// import 'vue-wysiwyg/dist/vueWysiwyg.css'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// // Drag And Drop Css
// import 'vue2-dragula/styles/dragula.css'

// // Icon Files
// import 'weather-icons/css/weather-icons.min.css'
import '../assets/themify-icons/themify-icons.css'
import '../assets/iconfont/iconfont.css'
import './fa-icon.css'


// leaflet map css
// import 'leaflet/dist/leaflet.css'

// Global Scss File
import '../assets/scss/_style.scss'



// WEBPACK FOOTER //
// ./src/lib/VuelyCss.js